// import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { LOGO_LOADER } from '../../Assets/images';
import Image from 'next/image';
import { InnerLoaderContainerStyled, InnerLoaderStyled } from './LoaderStyled';

const WithLoader = (WrappedComponent, withLogo = false, height=300) => {
  function HOC(props) {
    const [isLoading, setLoading] = useState(true);

    const setLoadingState = (isComponentLoading) => {
      setTimeout(() => {
        setLoading(isComponentLoading);
      }, 1000);
    };

    const getClassName = () => {
      const loderClass = withLogo ? ' loaderWithLogo' : ' loaderWithoutLogo';
      return isLoading ? 'fadeIn ' + loderClass : 'fadeOut ' + loderClass;
    };

    return (
      <InnerLoaderContainerStyled style={isLoading ? { minHeight: height } : {}}>
        {/* this could be leave for now as added fadeIn/fadeOut-  {isLoading && */}
        <InnerLoaderStyled className={getClassName()}>
          <div className={`loaderBox ${withLogo ? 'loaderBoxWithLogo' : ''}`}>
            {withLogo && (
              <div className="aster_logo">
                <Image src={LOGO_LOADER.src} alt="myAster" layout="fill" />
              </div>
            )}
            <div className="threeDots">
              <div className="loaderDots dot1"></div>
              <div className="loaderDots dot2"></div>
              <div className="loaderDots dot3"></div>
            </div>
          </div>
        </InnerLoaderStyled>
        {/* } */}
        <div className={isLoading ? 'bluredBG' : ''}>
          <WrappedComponent {...props} setLoading={setLoadingState} />
        </div>
      </InnerLoaderContainerStyled>
    );
  }
  return HOC;
};

export default WithLoader;
